import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckIconGreen = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 14 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M13.2211 0.721008C13.5132 1.0131 13.5132 1.48667 13.2211 1.77876L5.45711 9.54278C5.06658 9.9333 4.43342 9.9333 4.04289 9.54278L1.15407 6.65396C0.861874 6.36176 0.861874 5.88801 1.15407 5.59581V5.59581C1.44602 5.30386 1.91927 5.30357 2.21157 5.59516L4.75 8.12738L12.1636 0.720758C12.4558 0.428904 12.9291 0.429016 13.2211 0.721008V0.721008Z",
		fill: "#079E88"
	})]
});
const ForwardRef = forwardRef(SvgCheckIconGreen);
export { ForwardRef as ReactComponent };
